/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
import { useCallback } from 'react';
import { Schema } from '@data-driven-forms/react-form-renderer';
import { useAxios } from '../context/AxiosContext';
import { useQuery } from 'react-query';

interface Props {
  form: string;
  entityId?: string | null;
  readOnly?: boolean;
}

export function useSchema({ form, readOnly = false }: Props) {
  const { authAxios } = useAxios();

  const fetchSchema = useCallback(
    async ({ form, readOnly }) => {
      const response = await authAxios.get<Schema>(`/schema/${form}`, {
        params: {
          readOnly
        }
      });

      return response.data;
    },
    [authAxios]
  );

  const { data, isLoading } = useQuery<Schema, Error>(
    ['form-schema', form, readOnly],
    () => fetchSchema({ form, readOnly }),
    {
      refetchOnWindowFocus: false,
      enabled: form !== null && !!form.length
    }
  );

  return { schema: data || { fields: [] }, isSchemaLoaded: !isLoading };
}
